import { useQuery } from '@tanstack/react-query';
import useApiFetch from './useApiFetch';
import { ApiEndpointEnum } from '@/enums/ApiEndpointEnum';
import type { Address } from '@/types';

export function useGetAddressById(id?: string | number | null) {
  const { get } = useApiFetch();
  const addressId = id != null ? String(id) : '';

  return useQuery<Address | null>({
    queryKey: ['address', addressId],
    enabled: Boolean(addressId),
    queryFn: async ({ signal }) => {
      const endpoint = `${ApiEndpointEnum.CommerceAddressBase}/${addressId}` as unknown as ApiEndpointEnum;
      const res = await get(endpoint, undefined, signal);
      // Backend returns address object; ensure it matches Address type subset
      if (!res) return null;
      return res as Address;
    },
    staleTime: 5 * 60 * 1000,
  });
}
